import { Link } from "react-router-dom";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-charcoal text-parchment">
    <div className="max-w-6xl mx-auto px-6 py-14">
      <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
        <div className="max-w-md">
          <p className="font-serif text-xl tracking-tight">
            Findora <span className="text-brass">|</span>{" "}
            <span className="italic">Stylely by Daden</span>
          </p>
          <p className="mt-4 text-xs leading-relaxed text-parchment/60" data-testid="footer-disclosure">
            Findora is a participant in the Amazon Services LLC Associates
            Program. As an Amazon Associate, Findora earns from qualifying
            purchases made through links on this site — at no additional cost to
            you.
          </p>
        </div>
        <nav className="flex gap-8 font-mono text-[11px] uppercase tracking-[0.25em] text-parchment/60">
          <Link data-testid="footer-catalog-link" to="/" className="hover:text-brass transition-colors">
            Catalog
          </Link>
          <Link data-testid="footer-about-link" to="/about" className="hover:text-brass transition-colors">
            About
          </Link>
          <Link data-testid="footer-disclosure-link" to="/disclosure" className="hover:text-brass transition-colors">
            Disclosure
          </Link>
          <Link data-testid="footer-privacy-link" to="/privacy" className="hover:text-brass transition-colors">
            Privacy
          </Link>
        </nav>
      </div>
      <div className="mt-12 pt-6 border-t border-parchment/10 font-mono text-[10px] uppercase tracking-[0.25em] text-parchment/40">
        © 2026 Findora | Stylely by Daden — All picks independently reviewed
      </div>
    </div>
  </footer>
);
